export const environment = {
    production: true,
    userTokenStore: 'cbtadmintkn',
    apiURL: 'https://admin-webapi.webtest.ng/api/',
    //for some reason, the request times out on long running requests after 2 minutes so we do the reports on a different port
    //apiReportURL: 'https://admin-webapi.webtest.ng/api/',
    clientInformationStore: "ytyreryt",
    opPermissionStore: "opstore",
    
    serviceurl: `//proctorservices.webtest.ng`,
    //serviceurl2: `//proctorservices2.webtest.ng`,
    cbtserviceurl: `https://cbtapi.webtest.ng`,
    meetingServiceRootUrl: 'https://api.vcircle.ng/',
    mediasoupScheme: 'https',
    preprod: false,
    accesscodekey:'acProctor',
    proctorusername:'uProctor'
  };

  